import { useState, useEffect } from 'react';
import { TCSAlert, getAlertStack } from './addCSAlert';

/**
 * Hook to get the current alert.
 */
export function useCSAlert() {
  const [currentAlert, setCurrentAlert] = useState({} as TCSAlert);

  useEffect(() => {
    /**
     * Updates the current alert.
     */
    function alertStackUpdated() {
      setCurrentAlert(getAlertStack() ? getAlertStack()[0] : ({} as TCSAlert));
    }

    window.addEventListener('alertStackUpdated', alertStackUpdated);

    return () => {
      window.removeEventListener('alertStackUpdated', alertStackUpdated);
    };
  }, []);

  return currentAlert;
}
